export enum UserChallengeParamName {
  CODE_DELIVERY_DESTINATION = 'CODE_DELIVERY_DESTINATION',
  CODE_DELIVERY_DELIVERY_MEDIUM = 'CODE_DELIVERY_DELIVERY_MEDIUM'
}
